var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTwitterLogoX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 5276.36 5276.36",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5276.36 2638.173c0 1457.027-1181.16 2638.187-2638.187 2638.187C1181.153 5276.36 0 4095.2 0 2638.173S1181.153 0 2638.173 0C4095.2 0 5276.36 1181.147 5276.36 2638.173",
    fill: "#100f0d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2794.787 2562.76L3846.64 4088.053l-421.04-21.706-858.84-1239.28zm-1380.174-1398.2h415.974l839.24 1216.987-228.374 264.706zM4301.64 4342.133L2950.293 2382.52 4155.12 986l-250.787-35.373-1079.013 1250.68-873.773-1267.08H974.724L2286.04 2826.373l-1274.57 1477.36 262.32 22 1137.557-1318.546L3300.76 4290.56z",
    fill: "#fff"
  })));
}
export default SvgNewTwitterLogoX;